import { render, staticRenderFns } from "./ReferralCodesList.vue?vue&type=template&id=90a9a8b8&scoped=true&"
import script from "./ReferralCodesList.vue?vue&type=script&lang=ts&"
export * from "./ReferralCodesList.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralCodesList.vue?vue&type=style&index=0&id=90a9a8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a9a8b8",
  null
  
)

export default component.exports